// 常用进制快捷选项
export const COMMON_BASES = [2, 4, 8, 10, 16, 32]

// 所有支持的进制 (2-36)
export const ALL_BASES = Array.from({ length: 35 }, (_, i) => i + 2)

// 默认输入进制
export const DEFAULT_INPUT_BASE = 10

// 默认输出进制
export const DEFAULT_OUTPUT_BASE = 16
